import { createApp } from 'vue';
import Woff2ToOtfConverter from '@/Components/Woff2ToOtfConverter.vue';
import '@styles/app.css';

createApp(Woff2ToOtfConverter).mount('#woff2-to-otf-converter');
